"use client";
// import Image from "next/image";
import React, { useState } from "react";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);

  // Toggle the Read More state
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  // rohailjohn
  return (
    <>
      <div
        className={`${isReadMore ? "line-clamp-5" : ""} overflow-hidden`}
        style={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
        }}
      >
        {/* {text} */}
        <p
          dangerouslySetInnerHTML={{ __html: text }}
          className="updatedparapremu pt-6"
        ></p>
      </div>
      {text.length > 380 && (
        <div
          onClick={toggleReadMore}
          className="style-redmore"
          style={{
            color: "#D5AF34",
            fontSize: "17px",
            display: "inline-block",
            marginLeft: "1px",
            cursor: "pointer",
          }}
        >
          {isReadMore ? "Read More" : "Show less"}
        </div>
      )}
    </>
  );
};
function banner({ Mydata }) {
  const data = Mydata[1];
  return (
    <div>
      <div className="mx-auto max-w-7xl  pt-12">
        <div className="text-center px-6">
          <h2 className="text-3xl secondary font-bold">
            {data.title}
            <span className="text-[#D5AF34]">{data.subtitle}</span>
          </h2>
          <p
            className="updatedparapremu display pt-4 mb-12"
            dangerouslySetInnerHTML={{ __html: data.des }}
          ></p>
          <div className="updatedparapremu display-desktop pt-4 mb-12 ">
            <ReadMore maxLines={5}>{data.des}</ReadMore>
          </div>
        </div>
      </div>
    </div>
  );
}

export default banner;
